<template>
  <div id="home-view">
    <!-- 热门软件展示的轮播图 -->
    <div id="hot-software-show" v-if="false">
      <el-carousel indicator-position="outside">
        <el-carousel-item v-for="item in 4" :key="item">
          <div style="background-color: blue; height: 100%;">
            <h3 text="2xl" justify="center">{{ item }}</h3>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 公司优势介绍 -->
    <div id="our-introduction">
      <div class="title">
        为什么选择我们
      </div>
      <!-- 介绍公司优势的一堆卡片 -->
      <div class="box-card">
        <el-card v-for="{title, text, headerBgColor, imgUrl} in OurReasons">
          <template #header>
            <div class="header" :style="`background-color: ${headerBgColor};`">
              <img :src="imgUrl"/>
            </div>
          </template>
          <template #default>
            <div class="default">
              <div class="default-title">{{title}}</div>
              <div class="default-text">{{text}}</div>
            </div>
          </template>
        </el-card>
      </div>
    </div>

  </div>
</template>

<style scoped>
#hot-software-show {
  color: #475669;
  background-color: #e7f2fa;
  opacity: 0.75;

  text-align: center;
}


#our-introduction {
  /* background-image: url('https://yixingsoft.com/assets/productAdvantagesBgc.3b577885.png'); */
  padding: 5vh 0;
  .title {
    font-size: 32px;
    font-weight: bold;
    text-align: center;
    padding-bottom: 5vh;
  }

  .box-card{
    cursor: pointer;

    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;

    /* 在flebox中使用gap属性，需要chrome-84的支持 */
    /*   为了兼容性，改为在每一项内部设置margin，设置margin时大小要除以2 */
    /* gap: 20px; */

    justify-content: center;

    .el-card {
      margin: 10px 10px 10px 10px;

      flex-basis: 220px;
      border-radius: 24px;
    }

    :deep(.el-card__header) {
      padding: 0;
      .header {
        height: 192px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          /* width: 100px; */
          transition: scale 0.5s ease;
        }
        img:hover {
          scale: 1.1 1.1;
        }
      }
    }

    :deep(.el-card__body) {
      padding: 0;
      .default{
        height: 167px;
        .default-title {
          color: #333333;
          font-size: 24px;
          text-align: center;
          font-weight: bold;
          padding-top: 36px;
          padding-bottom: 36px;
        }
        .default-text {
          font-size: 14px;
          text-align: center;
          color: #666666;
        }
      }
    }
  }
}

@media (max-width: 1024px) {
  #our-introduction {
    padding: 5vh 5vh;
    .box-card{
      flex-direction: column;
      justify-content: center;

      align-items: center;
      .el-card {
        margin: 10px 0 10px 0;
        width: 100%;
        max-width: 450px;
        flex-basis: 359px;
      }
    }
  }
}
</style>

<script lang="ts" setup>
/* definePageMeta()是编译器宏，不用实际代码运行 */
definePageMeta({
})

import * as Vue from 'vue'
import AppConfig from '@/AppConfig'

import {
  ElCarousel, ElCarouselItem,
  ElCard
} from 'element-plus'

const OurReasons = Vue.ref([
  { title: '安全', text: '100%干净，安全，隐私保护',
    headerBgColor: '#cde1fc', imgUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABF1BMVEUAAAAadvmJtvscdfone/mGtfyEtP0bdPoedfqItvuEs/uLt/t6rvsrffl7rvuLuPsbdPkpfPl9sPuMuPwbc/kkevkneviGtvyAsfgcdPkbdPmHtvsfdvuHtfqHtvyGtPwcdPn///8vgPlzqfskeflFjvpKkPp3q/tSlfp6rft/sPszg/koe/krfflvp/uGtftjoPpgnvogd/k2hPlcnPpBjPo+ivlOk/o7iPlmovtWmPqLuPtrpfsbdPl8r/uBsvuDs/uItvsedvltpvtamvo4hvlZmfpoo/v8/f/3+v/u9f7z+P6fxPzl7/681v3d6v7X5/6/2P2szP2RvPyYwPzq8v7N4P3F2/3T5P240/2myfy10v241Py0rUZzAAAAIXRSTlMAHyPz8aRubkv18/Lx2dfW1rmzsbGdb1Ago6Fzc3FXUlGMh+q7AAAC80lEQVRYw82T6VbaUBCABwXc97V7p5EGqGVpoRSlImIlSFgCCKh9/+fo3CwVdW6i5v7odzgnwyxfbiYn4DIT31pbOn4mS2tb8RmYZiZWO34psSnV+4VaCBY+gMubbEjegc1eNjR79n4WT0OzKPYUqyogBrCfVkF1H+JpJcRh80QJm7CaUsIqLKsRLYOuCHUiTRGga5rvzyWwTd2JMkFoZrfd1wPbgkTp6xYSzXE2SFT3YzAy0KNrZvxaoSJF67dRYIw7TTtoXZ/Iu6WirOVMX/a1SiVz4zonQ6mowVExu2jTG3op7ymvbursCJQZzJbzKJ30dFa/ddN9boYVNZ3lNh4VhhMUZDhRjoF6rXSOJfWHiimmIBOVczIuEXVOlGcgUS4vQ4iY9ItEGicqMJAoX5AhRExaJso9zOkjy5FfSUTnDAaJHqQ0OsjAjijIMDNwwdCkt3Y/IzzNjB22ECvMDBwxiF47qN7k7GtGeNJOURyXmWFFtAZdXOsGtsue58Sp0Ss1LjhRkqGHeCyuDbp7O5d0PG5Np++Wm2FFHcS+HQyQTGnhSXk1Sk2eLBoi9pzIRIHn8W7CikoMddpDwQlN26Pf1Wh/p9wMKxLdAzccGvc8KdImWdFnjj49mxdXLW2qQk9msSO8KG8g1rlCgQopiYhljDiSHLXLT0CCpUIr1h+ny3SgGj8BCR7aRbv0KDuh3SWeJxLf2/XDpIloNGSiooQsIg7vp2pOigeKMjo0NphOVGlBY2k7/JCR6JHJvPt/aog3Jm0nkYxkm0xWyflTNMX3m5R3w085pS4NX6ZFmBPH6yZ9mkkkJ2Eh0dPyHSSshF8v/PYl20KX5sC/E777Q1+pzfgooJFEAZzfGjgqB7bBl2CK509oIpEa4JMi/kNR9KsSorCiRrQCG4dK2IBdNaJdiBweKOAwArCjQrQDAJFoeE80AsT8wbewzIPN27CeOXD5OHsWgtl5+Efk1dmvF3L2OgLTROa212efK5ld357zNH8B+rTAoMPEZeQAAAAASUVORK5CYII=',
  },
  { title: '专业', text: '专业的支持服务，7*24支持',
    headerBgColor: '#fbeedf', imgUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABC1BMVEUAAAD+tm7/tm7+ixn+t3H9ixj9kCL/tm3/tm7/tW3+jBr+t3H9jh79ihf/t23+sWX9kST+smb+uHL+ihj+kSL+jBf8ixn9jx//tm//ihb/r2j9jBn+tGz+tW3/tm/9kib+rl3+s2f+sWP9li/9lCr9kCL////+qVT9mTX9mzn9nT39ixn9n0D+r2D+tGr+p1H9jh7+tWz9mDL9jRz+rFn+pk7+t3D+pUv+pEn+okb9oUT+q1f+uHP/9Or//v3//fz+9+//+/f/+fP/7dz+5Mn+3bz+vXz/8eP/6dP+38H+06j//Pr+5s7+w4f+wIP+2rb+y5j+yZP+u3f+69f+17D+s2n+0aP+zp/+xY2jV1/rAAAAH3RSTlMA/iIe9PPxsqRuTP1wbVDx2dfW1rmxop1yIyD68/JXRXKGugAAAthJREFUWMPNktd22kAURYdiikvcaxqQ5FACyDiAQIAkegfTbP//l2QuwSskGsHCmgfvlzlzR2yOClvhDvrPvOUd8Z75g262jjtwkH8jB4E11Rdv3gHeD2zFjcshN2zJB1fGIa5lJ/enjGM+03MKpCUQYOxukZbBHQuGpRBkfjkiPzuVIzplxxEpHLOIJOSJUpKQJwpJ4h2KspKwE7k6BgTUeraikpgZbJiUxNiIRoBRsVID2naiqJAOMBeMFwbwEhUiFrWAfkR00ATqu4gGwFh4kNGBllikCCjrMCKKkC4wEB4IRQ2gqYjJ69DzQlHOiotfHM7Z0AC6orlI1F1eGx2l/j/IjJRcGeJ/YaqFMC+UVtUGauF/D4YGnlWVXoRqRSBqAg2+dIBKaH0+7QM9VaVPIyQQFSxUgTJfQiZQV/6OwzWgQ/s6MClYEIi4YExrukrVXqfZCtAmT56PhwJR0cIzgB6FlgHMV0OF96iUeIiYvFjB+isustAE8EhhAmCyHBUGgBnhgYrVlaJApFkpNgB9SKkHGC0K3F3N81VpUzFNABMNC511wULTnvh+SgczwExpQlFSRK4O9A940LjSzL4AGPEdVa2mk0KYeEy3UAuvQsUAJjRtUrHkDiJOyQTMEA9ZE5wezXr06JJ2ooQNqRqvEuUhzMOYJo/0MhN22IhIUAXqKg+50ZT2Qx2YJ3YVEeU+MNNed1MD6CbsYXF7WrxDI/knL7h1wLMtXGQP3U13mUI1oK7F3yQi6PnO+aqYQFuNbxTFNtID8BQrtgEzGtsIF21kTO98BlRTMQciogvCcMW2iR62EB8A0FsP2+CiLSSaujl62C76Jol3KPouiXco+ioJeSKfHI+PncgRnbCLH1K4YIdyRIfMI0fkYez6XgLXjDGPz7nH52Gc/ftfDrnfZ0sOnYqO2Ir9vZ8O2KM+KzxXb9Z8vPKwdW6PLs/3du5yfnl0uxL8Bg3mVUDOvVJWAAAAAElFTkSuQmCC',
  },
  { title: '保证', text: '提供试用，以卓越的信誉保证',
    headerBgColor: '#dedafd', imgUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA5FBMVEUAAABsS/9oRv+ahP+ag/+Zg/+Zgf9rSP9pR/+Zg/+UfP9xUP+Ufv+chf9qR/9wUP+Wff+chv9pSP9qSP9tTP+ag/9vTf+TgP9tSf+YhP+Sev9xUf+XgP92V/+Pdv+Mcv97Xf+HbP+Vff90VP9vTv+Jb/9tS/+Faf+BZf9+YP+bhf95Wv9qSP+ag/9/Yv+DZv////+OdP/w7f+yof/PxP/Bs/+ijf/6+f/39f/l4P+nlP/u6v/SyP/Dtv+1pf/z8f/g2f/b0/+eiP/Xzv+ql//q5v/Huv+8rf+tm/+4p//Uyv/Kvv/BFW1PAAAAGnRSTlMA8h/zIqRuTG5Q8dnX1ta5s7Gxop1ybyBzV2+BVMAAAALBSURBVFjD3dEJU9pAGMbx5bbet22KENNaEAs8JCE3IQeX9vt/n4YkLWh3oyE7nU7/ju67L/E3GSVp1frZUaWXs8rRWb1KtqvWejtX26I+VXoFqnwgaVf9gl0lzod+4eJ3qlaahaus/061JodqhNw0uXRD6nygOjmVuHRKDvlAh2SfD7RPBE7911CLzxdp8elvQf2lP5/q+tRUFeEtaMSs5ZrYZDjBKCvSZmXNAZgTxQp62pNqAwj7bXZMaAHoam9z13zAUHJDoxBwmq9eUQaWeSEXcP9YCn6GRO6pSeGMsm07QLSnFkE5aoeYCjtD2785suEwoDtmTcudqN5cB2TveeJa/fXSAqKTEhtysBacSFDGqmdHXrhee1BzQrIqvbgLE6yPGfR2TmjyaqEgPgysqFCHlTxOh+f75FQQHw5+0B5/BwTpBeTC2xUSXkAabCo0ZCWP0wFCciqIjyYM2uNvQKosy4i+/Q0kMaAuK3kc/RA0TcNK04RoVhDve5Bpj2dCSWglZwrNYOaEFnRoApUKDViNMe7Gg9mJD80IkyueaI+TATMX/t3mtoQ6XJ8tQKJCD+yCqS2lY8eBm0wTmNSHqdDsKTnbpm6lwzRIVvcGVu+HdMySoatiPFi/2ryVfhTCHtAhkdICRjsdFfgdBeEwva4ATaRGhbo25p107k2BpZim6ViIOSBRMGDepfPQEsTN+/gPuSCxb0AOXu2ifxi8gciCHumNbMCRthaiNY82D4+sCOuDrgrAc0eJEkwieDqLRjbELPARZcw9c4oofTF8zIJuMxqNbSTpvtK9zSyCMhtIgTXT2sklGyoYf+gLp/5B6DOnSImPUyIHfKADcsIHOiHXX7l0Tcp8oDIhlzycS0JIufStcKUyiWoUhxok7mNRZ4+kNUrfC1RqkN+VL3Z3Lspku/Le+XEp97scn+/9Yn4CEWnP2xVLTQsAAAAASUVORK5CYII=',
  },
  { title: '可靠', text: '拥有超过10年经验团队打造出品',
    headerBgColor: '#ebd5fd', imgUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA9lBMVEUAAADXl//Ymf+yO//Ym/+xOP+1Qv/Yl/+yO/+yOP/Zl//Xlv/Tjf+2Rf/Tjv/ZnP+yN/+2RP/UkP/anf+xN/+yOP+yO/+vM//Tkv+0Qv+zQP/ZmP+6Tf+4SP+2Q/+0Pv+yOf/Rh//CYP/Jc//Zm//PhP/Nff/Si//Tjv/Vkf+7Uf/Wlf/XmP/GbP/EZv/DZP/////Hb//Faf/Ogf++WP/Lef+9Vf/Kdv/Vkv+8U/+/W//AXf+/XP/58P/aoP/+/P/15f/8+P/w2f/ry//px//jtv/36//y3v/v1v/lvf/kuf/is//grv/eqv/cpf/t0f/szf/nwv/AtTHVAAAAHHRSTlMAbyMe9PPxpKBvUPPx2dfW1rmzsbFPSiMgcG9Xd9hVOwAAAoxJREFUWMPNzudy2kAUhuFDMSXu3Sm2Q4dQ9IEhdmyr0STRuf+byaKBhJndFba1P/wws7BHh3dEa9HI+XE8/07x4/NIlLZFk/kPS26lvsfzIcS/0FqkFlKEfF9qofnvFN2vhrYfZaFkVYEk0c2TEjcUqSgRoTM1oTM6KitxRAdqQgdUUkRdKKPIJwwVFFEXelBEHqp4XR3QHe+JXarLrm7rw/m4JA0VxSquiQ136mDD7GeKQpLQxAb03sQwpn0dK8P+ZDYduKux8Y7QEtAnm8tsCGvz54Jnw5wKQx2BMdB9+H8tVreelS2YRocnCpVNuP6PQqbDK1rQC4LQI8+BXmRfNQfmk+BxxkafnwpCFcBgXxMAduZRYAz7gQ/lOB50dpZMWLXHnEjRxpQbCkIO+uxcYNjJSbhYvCVkY8JOHeOczAgWH2pyAIOdQ5SaMmMMuZkwNGNnp9CUGohCdY6FcT1YDy43I9GasyOkY8SHWpw8UGwFqQElbigINXXMgzp1CxY/pQbPAIyG3BIo81MSrbowa9KOB3iCMWkCTYuVNLERsGgI5iTczrGSIev0WIdHWaGmA8z4seaxjpYVoaxYqysoaT2uw4U4DUGJdZayfXqR0Vhpuj1YdUbSdXqV0ubAaOva868y9Cz30gcGm0u261+kqB3gdVVq+/xO0C61gzz777TuGIGr9DtQm5XmhXrZYp3gTRYKNoDPzO/Yoz+7ZLqAvejsWqNfu7Vbb1hiITXohyKfMnSr5EO3iqgLJdR0EnR4p8QhnaoJndJXNaFvFLu7uw/7YaEYUepegRQRxRLhO4kYMVfhQ1fkS/8MKU1rl3thMnuX9E8s9fFOKkbbrtMXJ3vvfpeTi/T1OvAXFxg0hKXgLRUAAAAASUVORK5CYII=',
  },
  { title: '海量用户', text: `超过百万用户选择了${AppConfig.WEBSITE_UI_NAME}`,
    headerBgColor: '#ceeefc', imgUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABO1BMVEUAAAAgsfiZ0/8itfib1f4es/kltfgitPia1f8gtPmX1P+X0/+R0v6U0/6Iz/0xuPkmtfgvt/iL0f6c1f4ds/iN0f6d1f+P0v+P0P+Q0f0htPiY0/////8wuPmGz/1+zf17zP08u/k5uvk1uflSwvuN0f6J0P0st/gotvhAvPmR0v4ltfiW1P54y/whtPhDvfqa1f5ryPxnx/xJv/oes/hbxPtyyvxixvtexftXw/uBzv2Dzv2T0/5lxvtvyvxGvvp1yvxNwPpMv/puyPxPwPqc1f75/f78/v/n9v6W2f255v2Q1/31+/7v+f7e8/625P3b8v6K1Px80Pzr+P7h9P7V8P7L7P6o3/12zvzD6f6/6P2d2v2G1Pzx+v7R7v7I6/2r4f2h3vzj9f7Y8f7X8P685/2w4v2j3v3O7f4BmTaZAAAAHHRSTlMAHyNu9PO1oHBMpFD98/Hx8NnX1tazsW4goXNXSIg5rgAAA15JREFUWMOszr0KgCAYheHDh4PYz1CURlBTDeHgXK3d/y0F4uBanucCXl4kosdePR+pftSCnJjwm8lSswoFVIVE+0IaUeWLxSdp7mKNADAHwQS4mhGqHexGYTFwQgO6naJDywm1WEh4oYsEJwlWEl7oZWXsVhQEoyjqgyyaeQEv6qIkSATh8/8vTS1HmYtoev8nGD7NGJgT3rRuzmYf9vp8E+8TmQvss0qRDD/mAkuiJmaiKhZEzivM1cp0bjzpC+cjCFbOC4ytTJB7EGtP2jnbVaig7DzAb+TBC9GZmXoqIgWKkZMpimyJC9DnuQ/l9lHdQN3zXAGDNDFcgQLIbNc9QzZ3joJP191egE7YGGuBGkJ9cwiepQ/R43kVNqKoh1bf4a+ohELfL1CSaCMA/XgvkM2dAzg6rIH2/0YUKXD1jSC2H10I1RiOgLAxDgIpfOu78SFfj1UHdGPSRmFj7AQaiCMdAg+S5thGdyB1ddV50AgbUXTwgVMWlp7PE3+gysJUp4MksiTahIlrMKd6HTORtNJEFll2jSaOrF1398s03FtWoyajbYmiX9bHZqVhIAqjeZCzEbJxJVqGpEIjFcmY/qQmbdSWaNrE2vd/A+8VEWYccePZnAsfc0LML9Td0OwnciR1W7WZES5nm2FbmzDh0OW+R7DV5DBYlOXu2qwQ7HBIg6HxT4z+BEovxzfNPYJG54FHgVDSICyabYmSP2x3j1+NrnvL1cdAKPYxG6BsTVwtgKYysXJ1WgJvaWwKjXbj2ONnqAN7EtcWllX8TbrSrgTGR+Dpz9AcmIuTF+gTd7Kw0mMPNvNDdy7xPbzrsYV14o0FUOvxCp23RVOXFl7G4gyoxS5SH9QTC4k7RbcuM9irj3BUu6Q5ZHo8QuFO0cilhGfRdAGZ2Ee/oy5g5y5+KAcjeoZ+FKCGjUj3Vy9045KTqwqYqX2mYEfiBEp3iS5cDsvDp0AcYA2perVu3UFCIU4wDw4lmOAQnQeZ9A9xcGgXu/ALCf0P0dk/8dHKHKMACANBANzjSMJVJpBKsNFCQUjl/9+miIqt3s4DhheNJLxoIuFFAwk6ztOhcKKCOFNEKCdSyEIhQGI8CYDk1S0LDuaPDKe+OSkuFjxNMDwkbX+1JHgTjTV8TUKNejc7m52JysEtyLQAAAAASUVORK5CYII=',
  },
])

</script>
